export const docMapping={
    "companyAttorneyAuthorization": "Power of Attorney of Authorized Person",
    "companyArticleAssociation": "Company Article of Association",
    "coOpSocietyRegCertificate": "Co-operative Society Registration Certificate",
    "coOpSocietyByLaws": "Co-operative Society Bye-Laws",
    "coOpSocietyResObtLic": "Co-operative Society Resolution for Obtaining License",
    "coOpSocietyAuditReport": "Co-operative Society of Last Audit Report",
    "coOpSocietyIncomeExpenditure": "Co-operative Society Income-Expenditure Statement",
    "coOpSocietyBalanceSheetThreeYear": "Co-operative Society Balance Sheet for Last Three Years",
    "affidavit": "Proof of Probable Place Of Business and Market Committee",
    "enclousreDeclaration": "Enclosure Declaration",
    "declarations": "Declaration",
    "traderSignature": "Trader Signature",      
    "guarantorDeclaration": "Guarantor Declaration",
    "guarantorSignature_2": "Guarantor 2 Signature",
    "guarantorSignature_1": "Guarantor 1 Signature",
    "guarantorPhoto_2": "Guarantor 2 Photo",
    "guarantorPhoto_1": "Guarantor 1 Photo",
    "guarantorPanCard_2": "Guarantor 2 Pan Card",
    "guarantorPanCard_1": "Guarantor 1 Pan Card",
    "bankBalanceCertificate": "Bank Balance Certificate",
    "bankGuarntee": "Bank Guarntee",
    "itReturns_3": "IT Returns 3",
    "itReturns_2": "IT Returns 2",
    "itReturns_1": "IT Returns 1",
    "license": "License",
    "partnerShipDeed": "Partnership Deed",
    "proofOfBusinessPalace": "Proof of Place of Business",
    "chalanPayementLiceneseFee": "Challan (in support of payment of license fees)",
    "electionCard": "Election Card",
    "panCard": "Pan Card Number",
    "solvencyCertificate": "Solvency Certificate",

}